import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import * as firebase from 'firebase';
import FontAwesome from 'react-fontawesome';
import './expo-list.css';

/** @class CurrentExpo
  * Displays a current expo
  * @prop {String} expoID of the expo to show
  */
export default class CurrentExpo extends Component {
  /** @constructor
    * Creates a new instance of the expo
    */
  constructor(props) {
    super(props);
    this.firebaseRef = firebase.database().ref(`/expos/${props.expoID}/metadata`);
    this.state = {}
  }
  /** @function componentWillReceiveProps
    * Clears the old firebase database listener
    * and creates a new one pointed to the new
    * current expo.
    */
  componentWillReceiveProps(nextProps) {
    this.firebaseRef.off();
    this.firebaseRef = firebase.database().ref(`/expos/${nextProps.expoID}/metadata`);
    this.firebaseRef.on('value', (snapshot) => {
      this.setState(snapshot.val());
    });
  }
  /** @function componentWillMount
    * Connects the current series to the firebase database
    */
  componentWillMount() {
    this.firebaseRef.on('value', (snapshot) => {
      this.setState(snapshot.val());
    });
  }
  /** @function componentWillUnmount
    * Frees the firebase database listener
    */
  componentWillUnmount() {
    this.firebaseRef.off();
  }
  /** @function render
    * Renders the current expo
    */
  render() {
    return(
      <div className="current-expo">
        <a href={`https://${this.state.host}`} target="_blank">
          {this.state.host}
          <FontAwesome name="external-link"/>
        </a>
        {new Date(this.state.opens).toLocaleString()} to
        {new Date(this.state.closes).toLocaleString()}
        <span>
          <a href="#" onClick={()=>alert('reports coming soon...')}>
            <FontAwesome name="bar-chart"/>
          </a>
          <Link to={`/expos/${this.props.expoID}/properties`}>
            <FontAwesome name="edit"
              style={{color: "#965ba5", cursor: "pointer"}}
              />
          </Link>
          <a href="#" onClick={()=>this.props.archiveExpo(this.props.expoID)}>
            <FontAwesome name="archive"/>
          </a>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/series-list/current-expo.js